var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 24.2858C19.6807 24.2858 24.2858 19.6807 24.2858 14.0001C24.2858 8.31943 19.6807 3.71436 14.0001 3.71436C8.31943 3.71436 3.71436 8.31943 3.71436 14.0001C3.71436 19.6807 8.31943 24.2858 14.0001 24.2858Z",
    stroke: "#3A6647",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 20.8572C14.7102 20.8572 15.2858 20.2816 15.2858 19.5715C15.2858 18.8614 14.7102 18.2858 14.0001 18.2858C13.29 18.2858 12.7144 18.8614 12.7144 19.5715C12.7144 20.2816 13.29 20.8572 14.0001 20.8572Z",
    fill: "#3A6647"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 15.7143V14.8572C14.5935 14.8572 15.1735 14.6812 15.6668 14.3516C16.1602 14.0219 16.5447 13.5534 16.7718 13.0052C16.9988 12.4571 17.0582 11.8539 16.9425 11.2719C16.8267 10.69 16.541 10.1554 16.1214 9.73586C15.7019 9.3163 15.1673 9.03058 14.5854 8.91482C14.0034 8.79907 13.4003 8.85848 12.8521 9.08554C12.3039 9.3126 11.8354 9.69712 11.5057 10.1905C11.1761 10.6838 11.0001 11.2638 11.0001 11.8572",
    stroke: "#3A6647",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/Question.6a8493b191cff6c029c1c6d930911969.svg";
export { ForwardRef as ReactComponent };